import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import { compose } from '../core/compose.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  background: {
    property: 'background'
  },
  backgroundImage: {
    property: 'backgroundImage'
  },
  backgroundClip: {
    property: 'backgroundClip'
  },
  backgroundSize: {
    property: 'backgroundSize'
  },
  backgroundPosition: {
    property: 'backgroundPosition'
  },
  backgroundRepeat: {
    property: 'backgroundRepeat'
  },
  backgroundAttachment: {
    property: 'backgroundAttachment'
  }
};
const backgroundShorthandConfig = {};
backgroundShorthandConfig.bgImage = config.backgroundImage;
backgroundShorthandConfig.bgClip = config.backgroundClip;
backgroundShorthandConfig.bgSize = config.backgroundSize;
backgroundShorthandConfig.bgPosition = config.backgroundPosition;
backgroundShorthandConfig.bgRepeat = config.backgroundRepeat;
backgroundShorthandConfig.bgAttachment = config.backgroundAttachment;
const background = compose(system(config), system(backgroundShorthandConfig));

export { background };
